import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';

const quickLinks = [
  { to: '/topics', label: '求证专区' },
  { to: '/archive', label: '辟谣档案' },
  { to: '/about', label: '关于我们' },
  { to: '/about#contact', label: '提交线索' },
];

const categoryLinks = [
  { to: '/topics?category=entertainment', label: '娱乐瓜田' },
  { to: '/topics?category=tech', label: '科技爆料' },
  { to: '/topics?category=society', label: '社会热点' },
  { to: '/topics?category=consumer', label: '生活消费' },
];

export default function Footer() {
  return (
    <footer className="w-full bg-accent-900 text-accent-50">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-50 text-accent-900">
                <i className="ri-search-eye-line text-xl"></i>
              </span>
              <span className="font-heading text-xl font-bold">{siteInfo.name}</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-accent-100/90">{siteInfo.intro}</p>
            <p className="mt-4 font-heading text-base text-accent-100">{siteInfo.slogan}</p>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-heading text-sm font-semibold uppercase tracking-[0.2em] text-accent-200">站内导航</h3>
            <ul className="mt-4 space-y-3">
              {quickLinks.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="font-label text-sm text-accent-100/90 transition-colors hover:text-accent-50"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h3 className="font-heading text-sm font-semibold uppercase tracking-[0.2em] text-accent-200">热门话题</h3>
            <ul className="mt-4 space-y-3">
              {categoryLinks.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="font-label text-sm text-accent-100/90 transition-colors hover:text-accent-50"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-6 flex items-center gap-2 text-sm text-accent-100/90">
              <i className="ri-mail-line"></i>
              <a href={`mailto:${siteInfo.email}`} className="hover:text-accent-50">
                {siteInfo.email}
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-accent-700/60 pt-6 text-xs text-accent-200 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 {siteInfo.name}　保留所有权利</p>
          <p>内容仅为公开信息整理与求证记录，不构成法律或投资建议</p>
        </div>
      </div>
    </footer>
  );
}